import { RESIZE,MUEVE_TRANSDUCTOR,ADD_RECORRIDOS,SET_MODO_TRANSDUCTOR, RESETEA_RECORRIDO, TERMINA_RECORRIDO, MUEVE_SLIDER } from "../constants/actions-types";

const defaultSize = {
	width: 1000,
	height: 1000,
};

const defaultTransductor = {
	x:0.5,
	y:0.5,
	rot:0,
	basc:0,
};
const defaultAnatomia = {
	size:defaultSize,
	trans:defaultTransductor,
	recorridos:[],
	recorridoActual:-1,
	modo:"mov",
	siguienteModo:"",
	distancia:1,
	porcentaje:0,
	terminado:false,
};

function anatomiaReducer(state = defaultAnatomia,action){
	if(action.type === RESIZE){
		let newState = {...state};
		let cambiado = false;
		let newSize = {...newState.size};
		if(newSize.width !== action.size.width){ newSize.width = action.size.width;cambiado=true;}
		if(newSize.height !== action.size.height){ newSize.height = action.size.height;cambiado=true;}
		newState.size = newSize;
		if(cambiado)return newState;
	}if(action.type === ADD_RECORRIDOS){
		let newState = {...state};
		newState.recorridos = action.recorridos;
		return newState;
	}
	if(action.type === RESETEA_RECORRIDO){
		let newState = {...state};
		newState.recorridoActual = -1;
		newState.porcentaje = 0;
		newState.distancia = 1;
		newState.trans = {...defaultTransductor};
		newState.trans.rot = action.inicial.rot;
		newState.terminado = false;
		newState.modo="mov";
		return newState;
	}
	if(action.type === TERMINA_RECORRIDO){
		let newState = {...state};
		newState.terminado = true;
		return newState;
	}
	if(action.type === MUEVE_TRANSDUCTOR){
		let siguienteModo = "";
		let newState = {...state};
		let xDiff = action.dir.x;
		let yDiff = action.dir.y;
		if(newState.size !== null){
			xDiff = xDiff/newState.size.width;
			yDiff = yDiff/newState.size.height;
		}
		let newTransductor = {...newState.trans};
		if(newState.recorridoActual >= 0){
			let recorrido = newState.recorridos[newState.recorridoActual];
			if(newState.modo === "mov"){
				let vectX = recorrido.fin.x - recorrido.ini.x;
				let vectY = recorrido.fin.y - recorrido.ini.y;
				let vectMod = Math.sqrt(vectX*vectX + vectY*vectY);
				vectX = vectX / vectMod;
				vectY = vectY / vectMod;
				let vectD = xDiff * vectX + yDiff * vectY;
				let vecPosX = newTransductor.x - recorrido.ini.x;
				let vecPosY = newTransductor.y - recorrido.ini.y;
				let vecPos = vecPosX * vectX + vecPosY * vectY;
				if(vectD + vecPos > vectMod) vectD = vectMod-vecPos;
				if(vectD + vecPos < 0) vectD = -1*vecPos;
				newState.porcentaje = (vectD+vecPos)/vectMod;
				newTransductor.x += vectX * vectD;
				newTransductor.y += vectY * vectD;
				let xFin = recorrido.fin.x;
				let yFin = recorrido.fin.y;
				let dX = newTransductor.x - xFin;
				let dY = newTransductor.y - yFin;
				newState.distancia = dX*dX+dY*dY;
			}else if(newState.modo === "basc"){
				let perpX = Math.cos(newTransductor.rot);
				let perpY = Math.sin(newTransductor.rot);
				let variacion = xDiff * perpX + yDiff * perpY;
				newTransductor.basc -= Math.round(variacion* 180);
				if(newTransductor.basc < recorrido.ini ) newTransductor.basc = recorrido.ini;
				if(newTransductor.basc > recorrido.fin ) newTransductor.basc = recorrido.fin;
				newState.porcentaje = (newTransductor.basc-recorrido.ini)/(recorrido.fin-recorrido.ini);
				newState.distancia = (recorrido.fin - newTransductor.basc)/200;
			}else if(newState.modo === "giro"){
				let tanX = Math.cos(newTransductor.rot);
				let tanY = Math.sin(newTransductor.rot);
				let variacion = (xDiff * tanX + yDiff * tanY)*6;
				if(variacion > 1) variacion = 1;
				if(variacion < -1) variacion = -1;
				
				let iniRot = recorrido.ini;
				let finRot = recorrido.fin;
				let rot =  Math.asin(variacion);
				newTransductor.rot -= rot;
				if(recorrido.mod && recorrido.mod.includes("inv")){
					while(iniRot < finRot) iniRot += Math.PI*2;
					if(newTransductor.rot > iniRot ) newTransductor.rot = iniRot;
					if(newTransductor.rot < finRot ) newTransductor.rot = finRot;
					newState.porcentaje = 1-(newTransductor.rot-finRot)/(iniRot-finRot);
					newState.distancia = (iniRot - newTransductor.rot);
					console.log(iniRot,finRot, newTransductor.rot,newState.porcentaje);
				}else{
					while(finRot < iniRot) finRot += Math.PI*2;
					if(newTransductor.rot < iniRot ) newTransductor.rot = iniRot;
					if(newTransductor.rot > finRot ) newTransductor.rot = finRot;
					newState.porcentaje = (newTransductor.rot-iniRot)/(finRot-iniRot);
					newState.distancia = (finRot - newTransductor.rot);
					console.log(iniRot,finRot, newTransductor.rot,newState.porcentaje);
				}
			}/*else if(newState.modo === "din"){
				newState.porcentaje += xDiff;
				if(newState.porcentaje > 1) newState.porcentaje = 1;
				if(newState.porcentaje < 0) newState.porcentaje = 0;
				newState.distancia = 1-newState.porcentaje;
			}*/
		}else if(newState.recorridos.length > 0){
			newTransductor.x += xDiff;
			newTransductor.y += yDiff;
			if(newTransductor.x < 0) newTransductor.x = 0;
			if(newTransductor.x > 1) newTransductor.x = 1;
			if(newTransductor.y < 0) newTransductor.y = 0;
			if(newTransductor.y > 1) newTransductor.y = 1;
			let xFin = newState.recorridos[0].tipo === "mov"?newState.recorridos[0].ini.x:newState.recorridos[0].x;
			let yFin = newState.recorridos[0].tipo === "mov"?newState.recorridos[0].ini.y:newState.recorridos[0].y;
			let dX = newTransductor.x - xFin;
			let dY = newTransductor.y - yFin;
			newState.distancia = dX*dX+dY*dY;
		}
		if(newState.distancia < 0.005) {
			if(newState.recorridoActual < newState.recorridos.length -1)
				siguienteModo = newState.recorridos[newState.recorridoActual+1].tipo;
			else siguienteModo = "fin";
		}
		newState.trans = newTransductor;
		newState.siguienteModo = siguienteModo;
		return newState;
	}
	if(action.type === MUEVE_SLIDER){
		let newState = {...state};
		let recorrido = newState.recorridos[newState.recorridoActual];
		let xDiff = action.dir.x;
		let yDiff = action.dir.y;
		if(newState.size !== null){
			xDiff = xDiff/newState.size.width;
			yDiff = yDiff/newState.size.height;
		}
		if(recorrido.mod && recorrido.mod === "V")
			newState.porcentaje += yDiff;
		else
			newState.porcentaje += xDiff;
		if(newState.porcentaje > 1) newState.porcentaje = 1;
		if(newState.porcentaje < 0) newState.porcentaje = 0;
		newState.distancia = 1-newState.porcentaje;
		return newState;
	}
	if(action.type === SET_MODO_TRANSDUCTOR){
		let newState = {...state};
		newState.modo = action.modo;
		if(newState.recorridoActual < newState.recorridos.length - 1){
			newState.recorridoActual ++;
			newState.terminado = false;
			let recorrido = newState.recorridos[newState.recorridoActual];
			newState.distancia = 1;
			if(newState.modo === "mov"){
				let xFin = recorrido.fin.x;
				let yFin = recorrido.fin.y;
				let dX = newState.trans.x - xFin;
				let dY = newState.trans.y - yFin;
				newState.distancia = dX*dX+dY*dY;
			}else if(newState.modo === "basc"){
				newState.distancia = (recorrido.fin - newState.trans.basc)/200;
			}else if(newState.modo === "giro"){
				newState.distancia = (recorrido.fin - newState.trans.rot);
			}
			if(newState.distancia < 0.003) {
				if(newState.recorridoActual < newState.recorridos.length -1)
					newState.siguienteModo = newState.recorridos[newState.recorridoActual+1].tipo;
				else newState.siguienteModo = "fin";
			}else newState.siguienteModo = "";
			newState.porcentaje = 0;
		}
		return newState;
	}
	return state;
}

export default anatomiaReducer;
